import { render, staticRenderFns } from "./TextEditorV2.vue?vue&type=template&id=671ac6b1"
import script from "./TextEditorV2.vue?vue&type=script&lang=js"
export * from "./TextEditorV2.vue?vue&type=script&lang=js"
import style0 from "./TextEditorV2.vue?vue&type=style&index=0&id=671ac6b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports